import { render } from "./AppCamera.vue?vue&type=template&id=c81bbb9e"
import script from "./AppCamera.vue?vue&type=script&lang=js"
export * from "./AppCamera.vue?vue&type=script&lang=js"

import "./AppCamera.vue?vue&type=style&index=0&id=c81bbb9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__